import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';

import Button from '#globalComponents/Button/Button';

function ErrorFallback({ resetError }) {
	return (
		<div className="flex flex-col items-center justify-center min-h-[400px] gap-4 p-8">
			<h2 className="text-lg font-semibold text-text">Ein Fehler ist aufgetreten</h2>
			<p className="text-text text-center max-w-md">
				Beim Laden dieses Bereichs ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.
			</p>
			<p>Sollte das Problem bestehen bleiben, kontaktieren Sie uns unser info@b2b-hero.com</p>
			<Button onClick={resetError}>Erneut versuchen</Button>
		</div>
	);
}

export default function FeatureErrorBoundary({ children }) {
	return (
		<Sentry.ErrorBoundary fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}>
			{children}
		</Sentry.ErrorBoundary>
	);
}

ErrorFallback.propTypes = {
	resetError: PropTypes.func.isRequired,
};

FeatureErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired,
};
